import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "m-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("hr", { class: "w-100 m-1" })
], -1)
const _hoisted_3 = { class: "d-flex flex-row align-items-center mt-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label-sm m-1 text-nowrap" }, "Day Start:", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label-sm m-1" }, ":", -1)
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.modelValue.name), 1),
    _hoisted_2,
    _createElementVNode("form", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("select", {
        class: "day-hour form-select form-select-sm",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hour) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hourOptions, (v) => {
          return (_openBlock(), _createElementBlock("option", {
            value: v.num
          }, _toDisplayString(v.str), 9, _hoisted_5))
        }), 256))
      ], 512), [
        [_vModelSelect, _ctx.hour]
      ]),
      _hoisted_6,
      _withDirectives(_createElementVNode("select", {
        class: "day-minute form-select form-select-sm",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.minute) = $event))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.minuteOptions, (v) => {
          return (_openBlock(), _createElementBlock("option", {
            value: v.num
          }, _toDisplayString(v.str), 9, _hoisted_7))
        }), 256))
      ], 512), [
        [_vModelSelect, _ctx.minute]
      ])
    ])
  ], 64))
}